// Odontograma/constants/teethData.ts
import { ToothData } from "../types/types";

export const upperTeeth: ToothData[] = [
  { id: "18", quadrant: 1 }, // 1-1
  { id: "17", quadrant: 1 }, // 1-2
  { id: "16", quadrant: 1 }, // 1-3
  { id: "15", quadrant: 1 }, // 1-4
  { id: "14", quadrant: 1 }, // 1-5
  { id: "13", quadrant: 1 }, // 1-6
  { id: "12", quadrant: 1 }, // 1-7
  { id: "11", quadrant: 1 }, // 1-8
  { id: "21", quadrant: 2 }, // 2-1
  { id: "22", quadrant: 2 }, // 2-2
  { id: "23", quadrant: 2 }, // 2-3
  { id: "24", quadrant: 2 }, // 2-4
  { id: "25", quadrant: 2 }, // 2-5
  { id: "26", quadrant: 2 }, // 2-6
  { id: "27", quadrant: 2 }, // 2-7
  { id: "28", quadrant: 2 }, // 2-8
];
export const lowerTeeth: ToothData[] = [
  { id: "48", quadrant: 4 }, // 4-1
  { id: "47", quadrant: 4 }, // 4-2
  { id: "46", quadrant: 4 }, // 4-3
  { id: "45", quadrant: 4 }, // 4-4
  { id: "44", quadrant: 4 }, // 4-5
  { id: "43", quadrant: 4 }, // 4-6
  { id: "42", quadrant: 4 }, // 4-7
  { id: "41", quadrant: 4 }, // 4-8
  { id: "31", quadrant: 3 }, // 3-1
  { id: "32", quadrant: 3 }, // 3-2
  { id: "33", quadrant: 3 }, // 3-3
  { id: "34", quadrant: 3 }, // 3-4
  { id: "35", quadrant: 3 }, // 3-5
  { id: "36", quadrant: 3 }, // 3-6
  { id: "37", quadrant: 3 }, // 3-7
  { id: "38", quadrant: 3 }, // 3-8
];
